import { render, staticRenderFns } from "./EditorComponent.vue?vue&type=template&id=941ced8c&scoped=true"
import script from "./EditorComponent.vue?vue&type=script&lang=js"
export * from "./EditorComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "941ced8c",
  null
  
)

export default component.exports